import { ShopifyProduct } from './shopify';
import { Language } from '@/stores/languageStore';

/**
 * Helper function to get translated product title based on selected language
 * Falls back to original Hebrew title if translation is not available
 */
export function getProductTitle(product: ShopifyProduct['node'], language: Language): string {
  const rawTitle = (() => {
    switch (language) {
      case 'en':
        return product.title_en?.value || product.title;
      case 'ar':
        // Arabic removed from storefront UI; fallback to Hebrew.
        return product.title;
      case 'ru':
        return product.title_ru?.value || product.title;
      case 'he':
      default:
        return product.title;
    }
  })();
  
  // Remove emojis from title
  return rawTitle.replace(/[🔥⚡✨💪🎯🔌💡🛠️⭐🎁📦⚠️]/g, '').trim();
}

/**
 * Helper function to get translated product description based on selected language
 * Falls back to original Hebrew description if translation is not available
 */
export function getProductDescription(product: ShopifyProduct['node'], language: Language): string {
  const rawDescription = (() => {
    switch (language) {
      case 'en':
        return product.desc_en?.value || product.description;
      case 'ar':
        // Arabic removed from storefront UI; fallback to Hebrew.
        return product.description;
      case 'ru':
        return product.desc_ru?.value || product.description;
      case 'he':
      default:
        return product.description;
    }
  })();
  
  // Clean up description - remove emojis and bullet points
  return rawDescription
    .replace(/[🔥⚡✨💪🎯🔌💡🛠️⭐🎁📦⚠️•]/g, '')
    .replace(/^[^\w\u0590-\u05FF\u0600-\u06FF\u0400-\u04FF]+/, '')
    .trim();
}

/**
 * Get the first line/paragraph of the description for card previews
 */
export function getProductDescriptionPreview(product: ShopifyProduct['node'], language: Language): string {
  const fullDescription = getProductDescription(product, language);
  return fullDescription.split('\n')[0].trim();
}
